import localeConfig from 'config/locales.json';

export const getMarket = (locale: string): string => {
  const { locales }: Record<string, any> = localeConfig;
  return locales[locale].recipeMarket;
};
